<script>
    import dictionaryES from "../utils/dictionary/dictionary-ES";
    import dictionaryEN from "../utils/dictionary/dictionary-EN";

    import { dictionary, language } from "../utils/stores.js";
    import { getLanguage, setLanguage } from "../utils/token";

    import { onMount } from "svelte";

    let dict;

    const unsubscribe = dictionary.subscribe((value) => {
        dict = value;
    });

    onMount(() => {
        changeLanguage(getLanguage());
    });

    let changeLanguage = (lang) => {
        switch (lang) {
            case "es":
                dictionary.set(dictionaryES);
                break;
            case "en":
                dictionary.set(dictionaryEN);
                break;
        }
        setLanguage(lang);
        language.set(lang);
    };
</script>

<div class="ie-panel">
    <a href="http://windows.microsoft.com/en-US/internet-explorer/">
        <img
            src="images/ie8-panel/warning_bar_0000_us.jpg"
            height="42"
            width="820"
            alt="You are using an outdated browser. For a faster, safer browsing
      experience, upgrade for free today." />
    </a>
</div>
<div class="preloader" id="loading">
    <div class="preloader-body">
        <div id="loading-center-object">
            <div class="object" id="object_four" />
            <div class="object" id="object_three" />
            <div class="object" id="object_two" />
            <div class="object" id="object_one" />
        </div>
    </div>
</div>
<div class="page">
    <section class="section section-layout-3-outer">
        <div class="section-layout-3">
            <div class="section-layout-3-main">
                <div class="section-1 text-center">
                    <div class="container">
                        <div class="box-shadow-1">
                            <a class="brand" href="/">
                                <img
                                    class="brand-logo-dark"
                                    src="images/revista/logo.png"
                                    alt="Logo" />
                            </a>
                            <div
                                class="alert alert-success registerOk"
                                role="alert">
                                {dict['enviadoManuscrito']}
                                <a
                                    class="link link-icon link-icon-left"
                                    href="articulos-autor">
                                    <span class="icon mdi mdi-arrow-left" />
                                    <span>{dict['continuar']}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
<div class="snackbars" id="form-output-global" />
